/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ഇന്നലെ",
        "-2": "മിനിഞ്ഞാന്ന്",
        "0": "ഇന്ന്",
        "1": "നാളെ",
        "2": "മറ്റന്നാൾ",
        "future": {
          "one": "{0} ദിവസത്തിൽ",
          "other": "{0} ദിവസത്തിൽ"
        },
        "past": {
          "one": "{0} ദിവസം മുമ്പ്",
          "other": "{0} ദിവസം മുമ്പ്"
        }
      },
      "day-narrow": {
        "-1": "ഇന്നലെ",
        "-2": "മിനിഞ്ഞാന്ന്",
        "0": "ഇന്ന്",
        "1": "നാളെ",
        "2": "മറ്റന്നാൾ",
        "future": {
          "one": "{0} ദിവസത്തിൽ",
          "other": "{0} ദിവസത്തിൽ"
        },
        "past": {
          "one": "{0} ദിവസം മുമ്പ്",
          "other": "{0} ദിവസം മുമ്പ്"
        }
      },
      "day-short": {
        "-1": "ഇന്നലെ",
        "-2": "മിനിഞ്ഞാന്ന്",
        "0": "ഇന്ന്",
        "1": "നാളെ",
        "2": "മറ്റന്നാൾ",
        "future": {
          "one": "{0} ദിവസത്തിൽ",
          "other": "{0} ദിവസത്തിൽ"
        },
        "past": {
          "one": "{0} ദിവസം മുമ്പ്",
          "other": "{0} ദിവസം മുമ്പ്"
        }
      },
      "hour": {
        "0": "ഈ മണിക്കൂറിൽ",
        "future": {
          "one": "{0} മണിക്കൂറിൽ",
          "other": "{0} മണിക്കൂറിൽ"
        },
        "past": {
          "one": "{0} മണിക്കൂർ മുമ്പ്",
          "other": "{0} മണിക്കൂർ മുമ്പ്"
        }
      },
      "hour-narrow": {
        "0": "ഈ മണിക്കൂറിൽ",
        "future": {
          "one": "{0} മണിക്കൂറിൽ",
          "other": "{0} മണിക്കൂറിൽ"
        },
        "past": {
          "one": "{0} മണിക്കൂർ മുമ്പ്",
          "other": "{0} മണിക്കൂർ മുമ്പ്"
        }
      },
      "hour-short": {
        "0": "ഈ മണിക്കൂറിൽ",
        "future": {
          "one": "{0} മണിക്കൂറിൽ",
          "other": "{0} മണിക്കൂറിൽ"
        },
        "past": {
          "one": "{0} മണിക്കൂർ മുമ്പ്",
          "other": "{0} മണിക്കൂർ മുമ്പ്"
        }
      },
      "minute": {
        "0": "ഈ മിനിറ്റിൽ",
        "future": {
          "one": "{0} മിനിറ്റിൽ",
          "other": "{0} മിനിറ്റിൽ"
        },
        "past": {
          "one": "{0} മിനിറ്റ് മുമ്പ്",
          "other": "{0} മിനിറ്റ് മുമ്പ്"
        }
      },
      "minute-narrow": {
        "0": "ഈ മിനിറ്റിൽ",
        "future": {
          "one": "{0} മിനിറ്റിൽ",
          "other": "{0} മിനിറ്റിൽ"
        },
        "past": {
          "one": "{0} മിനിറ്റ് മുമ്പ്",
          "other": "{0} മിനിറ്റ് മുമ്പ്"
        }
      },
      "minute-short": {
        "0": "ഈ മിനിറ്റിൽ",
        "future": {
          "one": "{0} മിനിറ്റിൽ",
          "other": "{0} മിനിറ്റിൽ"
        },
        "past": {
          "one": "{0} മിനിറ്റ് മുമ്പ്",
          "other": "{0} മിനിറ്റ് മുമ്പ്"
        }
      },
      "month": {
        "-1": "കഴിഞ്ഞ മാസം",
        "0": "ഈ മാസം",
        "1": "അടുത്ത മാസം",
        "future": {
          "one": "{0} മാസത്തിൽ",
          "other": "{0} മാസത്തിൽ"
        },
        "past": {
          "one": "{0} മാസം മുമ്പ്",
          "other": "{0} മാസം മുമ്പ്"
        }
      },
      "month-narrow": {
        "-1": "കഴിഞ്ഞ മാസം",
        "0": "ഈ മാസം",
        "1": "അടുത്ത മാസം",
        "future": {
          "one": "{0} മാസത്തിൽ",
          "other": "{0} മാസത്തിൽ"
        },
        "past": {
          "one": "{0} മാസം മുമ്പ്",
          "other": "{0} മാസം മുമ്പ്"
        }
      },
      "month-short": {
        "-1": "കഴിഞ്ഞ മാസം",
        "0": "ഈ മാസം",
        "1": "അടുത്ത മാസം",
        "future": {
          "one": "{0} മാസത്തിൽ",
          "other": "{0} മാസത്തിൽ"
        },
        "past": {
          "one": "{0} മാസം മുമ്പ്",
          "other": "{0} മാസം മുമ്പ്"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "കഴിഞ്ഞ പാദം",
        "0": "ഈ പാദം",
        "1": "അടുത്ത പാദം",
        "future": {
          "one": "{0} പാദത്തിൽ",
          "other": "{0} പാദത്തിൽ"
        },
        "past": {
          "one": "{0} പാദം മുമ്പ്",
          "other": "{0} പാദം മുമ്പ്"
        }
      },
      "quarter-narrow": {
        "-1": "കഴിഞ്ഞ പാദം",
        "0": "ഈ പാദം",
        "1": "അടുത്ത പാദം",
        "future": {
          "one": "{0} പാദത്തിൽ",
          "other": "{0} പാദത്തിൽ"
        },
        "past": {
          "one": "{0} പാദം മുമ്പ്",
          "other": "{0} പാദം മുമ്പ്"
        }
      },
      "quarter-short": {
        "-1": "കഴിഞ്ഞ പാദം",
        "0": "ഈ പാദം",
        "1": "അടുത്ത പാദം",
        "future": {
          "one": "{0} പാദത്തിൽ",
          "other": "{0} പാദത്തിൽ"
        },
        "past": {
          "one": "{0} പാദം മുമ്പ്",
          "other": "{0} പാദം മുമ്പ്"
        }
      },
      "second": {
        "0": "ഇപ്പോൾ",
        "future": {
          "one": "{0} സെക്കൻഡിൽ",
          "other": "{0} സെക്കൻഡിൽ"
        },
        "past": {
          "one": "{0} സെക്കൻഡ് മുമ്പ്",
          "other": "{0} സെക്കൻഡ് മുമ്പ്"
        }
      },
      "second-narrow": {
        "0": "ഇപ്പോൾ",
        "future": {
          "one": "{0} സെക്കൻഡിൽ",
          "other": "{0} സെക്കൻഡിൽ"
        },
        "past": {
          "one": "{0} സെക്കൻഡ് മുമ്പ്",
          "other": "{0} സെക്കൻഡ് മുമ്പ്"
        }
      },
      "second-short": {
        "0": "ഇപ്പോൾ",
        "future": {
          "one": "{0} സെക്കൻഡിൽ",
          "other": "{0} സെക്കൻഡിൽ"
        },
        "past": {
          "one": "{0} സെക്കൻഡ് മുമ്പ്",
          "other": "{0} സെക്കൻഡ് മുമ്പ്"
        }
      },
      "week": {
        "-1": "കഴിഞ്ഞ ആഴ്‌ച",
        "0": "ഈ ആഴ്ച",
        "1": "അടുത്ത ആഴ്ച",
        "future": {
          "one": "{0} ആഴ്ചയിൽ",
          "other": "{0} ആഴ്ചയിൽ"
        },
        "past": {
          "one": "{0} ആഴ്ച മുമ്പ്",
          "other": "{0} ആഴ്ച മുമ്പ്"
        }
      },
      "week-narrow": {
        "-1": "കഴിഞ്ഞ ആഴ്‌ച",
        "0": "ഈ ആഴ്ച",
        "1": "അടുത്ത ആഴ്ച",
        "future": {
          "one": "{0} ആഴ്ചയിൽ",
          "other": "{0} ആഴ്ചയിൽ"
        },
        "past": {
          "one": "{0} ആഴ്ച മുമ്പ്",
          "other": "{0} ആഴ്ച മുമ്പ്"
        }
      },
      "week-short": {
        "-1": "കഴിഞ്ഞ ആഴ്‌ച",
        "0": "ഈ ആഴ്ച",
        "1": "അടുത്ത ആഴ്ച",
        "future": {
          "one": "{0} ആഴ്ചയിൽ",
          "other": "{0} ആഴ്ചയിൽ"
        },
        "past": {
          "one": "{0} ആഴ്ച മുമ്പ്",
          "other": "{0} ആഴ്ച മുമ്പ്"
        }
      },
      "year": {
        "-1": "കഴിഞ്ഞ വർഷം",
        "0": "ഈ വർ‌ഷം",
        "1": "അടുത്തവർഷം",
        "future": {
          "one": "{0} വർഷത്തിൽ",
          "other": "{0} വർഷത്തിൽ"
        },
        "past": {
          "one": "{0} വർഷം മുമ്പ്",
          "other": "{0} വർഷം മുമ്പ്"
        }
      },
      "year-narrow": {
        "-1": "കഴിഞ്ഞ വർഷം",
        "0": "ഈ വർ‌ഷം",
        "1": "അടുത്തവർഷം",
        "future": {
          "one": "{0} വർഷത്തിൽ",
          "other": "{0} വർഷത്തിൽ"
        },
        "past": {
          "one": "{0} വർഷം മുമ്പ്",
          "other": "{0} വർഷം മുമ്പ്"
        }
      },
      "year-short": {
        "-1": "കഴിഞ്ഞ വർഷം",
        "0": "ഈ വർ‌ഷം",
        "1": "അടുത്തവർഷം",
        "future": {
          "one": "{0} വർഷത്തിൽ",
          "other": "{0} വർഷത്തിൽ"
        },
        "past": {
          "one": "{0} വർഷം മുമ്പ്",
          "other": "{0} വർഷം മുമ്പ്"
        }
      }
    },
    "locale": "ml"
  });
}